<template>
    <div class="app-card mt-5">
            <div style="margin:0 20px;">
                <label style="font-size: 16px;border-bottom: 1px solid  #EEEEEE;display:block;text-align: center;height: 30px;line-height: 15px;font-weight: bold;" class="mt-3 ">
                	{{$t("left.tags")}}
                </label>
                <!-- <div v-for="tag in tagList">
                    <label @click="findtagposting(tag.tagId,tag.tagName)"  class="tag" style="text-align: left;font-size: 16px;font-family: PingFangTC-Regular;padding: 5px;">
                        {{tag.tagName}}
                    </label>
                </div> -->
                <div class="mt-3 mb-3">
                    <Tag v-for="(tag, index) in tagList" :key="tag.tagId" type="border" color="#41B8BC" class="body-2">
                        <span @click="findtagposting(tag.tagId,tag.tagName)">{{tag.tagName}}</span>
                    </Tag>
                </div>
                <div v-show="isShowAll" class="postmiddle-right mt-3">
                    <ul style="list-style: none;font-size: .8rem; margin-bottom: 20px; text-align: center;">
                        <li>
                            <span @click="showAllTag" class="body-2 ml-1 pointer">
                                <span >{{$t("left.showall")}}</span>
                                <v-icon medium style="vertical-align:middle;">keyboard_arrow_down</v-icon>
                            </span>
                        </li>
                    </ul>
                </div>
                <div v-show="isShowUpward" class="postmiddle-right">
                    <ul style="list-style: none;font-size: .8rem;margin-bottom: 20px;text-align: center;">
                        <li>
                            <span @click="upwardTag" class="body-2 ml-1 pointer">
                                <span>{{$t("left.Upward")}}</span>
                                <v-icon medium style="vertical-align:middle;">keyboard_arrow_up</v-icon>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
    </div>
</template>
<style>
.tag:hover{
	color: #41B8BC;
	cursor: pointer;
}
</style>
<script>
    import Vue from 'vue'
    import config from '../config.js'
    export default {
        data(){
            return{
                isShowAll: false,//是否显示显示全部
                isShowUpward: false,//是否显示向上收起
                tagList: [],    //显示的标签集合
                allTagList: [], //所有标签集合
            }
        },
        computed: {
            
        },
        created(){
            
        },
        mounted:function(){
            this.getAllTag();
        },
        watch:{
            
        },        
        methods: {
            //根据标签查找帖子
        	findtagposting(tagId,tagName){
	           if (tagId!= null && tagId.trim() != '') {
                    this.$router.push({name:'posting',query:{"tagId":tagId,"tagName":tagName}});
                } 
            },
            //查询所有标签
            getAllTag(){
                this.$http.get(config.baseUrl + "tag/open/getTagByCondition/hot").then(function(successData){
                    let data = successData.data.result;
                    this.allTagList = data;
                    if (data.length >20 ) {
                        for (let i = 0; i < 20; i++) {
                            //向数组中添加元素
                            this.tagList = this.tagList.concat(data[i]);
                        }
                        this.isShowAll = true;
                    }else{
                        this.tagList = data;
                    }
                });
            },
            //显示所有
            showAllTag(){
                this.tagList = this.allTagList;
                this.isShowAll = false;
                this.isShowUpward = true;
            },
            //收起标签
            upwardTag(){
                this.tagList = [];
                for (let i = 0; i < 20; i++) {
                    //向数组中添加元素
                    this.tagList = this.tagList.concat(this.allTagList[i]);
                }
                this.isShowAll = true;
                this.isShowUpward = false;
            },
        }
    }
</script>





// WEBPACK FOOTER //
// Left.vue?849a42f6